import "./ClassSelectionCard.css";
import React, { useMemo, useState } from "react";
import { IRpgClass } from "../../models/IRpgClass";

export interface IClassSelectionCardProps {
    rpgClass: IRpgClass;
    isSelected: boolean;
    isDisabled: boolean;
    subText?: string;
    imgSrc?: string;
    disabledReasonSummary?: string;
    onSelect: (cls: IRpgClass) => void;
}

const ClassSelectionCard: React.FC<IClassSelectionCardProps> = ({
    rpgClass,
    isSelected,
    isDisabled,
    subText,
    imgSrc,
    disabledReasonSummary,
    onSelect,
}) => {
    const [hasImageError, setHasImageError] = useState(false);

    const resolvedImgSrc = useMemo(() => {
        if (!imgSrc || imgSrc.trim().length === 0) {
            return "";
        }

        return imgSrc.trim();
    }, [imgSrc]);

    const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (isDisabled) {
            return;
        }

        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onSelect(rpgClass);
        }
    };

    return (
        <div
            className={`class-card${isSelected ? " is-selected" : ""}${isDisabled ? " is-disabled" : ""}`}
            onClick={isDisabled ? undefined : () => onSelect(rpgClass)}
            role="button"
            // aria-disabled={isDisabled}
            tabIndex={isDisabled ? -1 : 0}
            onKeyDown={onKeyDown}
        >
            {/* Optional image: if missing or errors, show NOTHING (per your requirement). */}
            {!hasImageError && resolvedImgSrc ? (
                <div className="class-card__thumb">
                    <img
                        className="class-card__img"
                        src={resolvedImgSrc}
                        alt={rpgClass.Name}
                        onError={() => setHasImageError(true)}
                    />
                </div>
            ) : null}

            <div className="class-card__content">
                <div className="class-card__header">
                    <div className="class-card__title">{rpgClass.Name}</div>

                    {isDisabled ? (
                        <span className="class-card__locked-label">
                            {disabledReasonSummary === "View mode active" ? (
                                <span>View mode active</span>
                            ) : <span>Requirements not met</span>}
                        </span>
                    ) : null}
                </div>

                {subText ? (
                    <div className="class-card__subtext">{subText}</div>
                ) : null}

                <div className="class-card__subtitle">{rpgClass.Description}</div>

                {isDisabled && disabledReasonSummary ? (
                    <div className="class-card__locked-summary">
                        {disabledReasonSummary === "View mode active" ? (
                            ""
                        ) : <span>{disabledReasonSummary}</span>}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ClassSelectionCard;
